import { Component, Input, OnInit } from '@angular/core';

@Component({
    standalone: false,
    selector: 'ziq-entity-attribute-icon',
    templateUrl: './entity-attribute-icon.component.html',
    styleUrls: ['./entity-attribute-icon.component.scss']

})
export class EntityAttributeIconComponent implements OnInit {

    @Input()
    isActive: boolean;

    @Input()
    activeIcon: string;

    @Input()
    notActiveIcon: string;

    @Input()
    hint?: string;

    constructor() { }

    ngOnInit() {
    }

}
